module.exports = __webpack_public_path__ + "img/vertical_7_2_7005.15929a00.png";